export default {
  home: {
    language: 'Language',
    theme: 'Theme',
    dark: 'Dark',
    light: 'Light'
  },
  dashboard: {
    to: 'To'
  },
  mediahub: {
    subscription: 'Manage Subscriptions',
    yearly: 'Yearly',
    demand: 'On Demand',
    subscribeDemand: 'Subscribe On Demand Plan',
    managed: 'Managed',
    subscribeManaged: 'Subscribe Managed Plan',
    reselect: 'Reselect Plan',
    deactivate: 'Deactivate',
    subscriptionTip: 'Why do you deactivate your subscription?',
    saveMoney: 'I want to save money',
    feature: "I can't find the feature I wan",
    other: 'Others',
    liveTip: 'Please note that after unsubscribing you will not be able to take live streams',
    plan: 'Choose a plan',
    monthly: 'Monthly',
    payperuse: 'Pay per Use',
    inputPeview: 'Input Preview',
    month: '/month',
    year: '/year',
    perInput: 'per active input',
    output: 'Output',
    perOuput: 'per output',
    format: 'Encoding Format',
    bitrateTip1: 'per encoding profile with video bitrate up to 10 Mbps',
    bitrateTip2: 'per encoding profile with video bitrate up to 30 Mbps',
    choosePlan: 'Choose this plan',
    back: 'Back',
    remainTip: 'Your remaining credit will automatically be applied to the new subscription',
    inputStream: 'Input Stream',
    outputStream: 'Output Stream',
    lowBitrate: 'Low Video Bitrate Encoding',
    highBitrate: 'High Video Bitrate Encoding',
    buy: 'Buy',
    cloudSubscription: 'Cloud Subscriptions',
    core: 'Number of CPU Cores',
    node: 'Nodes Subscriptions',
    CPU: '/per 4 CPU Core',
    payment: 'Manage Payment',
    manageTip: 'Are you sure to open the Manage Payment portal?',
    subscribeService: 'Subscribe to TVU Media Hub Service',
    save: 'Save',
    perMonth: 'per month',
    eachGroup: 'Each group has',
    bitrateTip: 'for a low video bitrate output',
    confirm: 'confirm'
  }
}
